import * as THREE from "three";
import { LineMaterial } from "three/addons/lines/LineMaterial.js";

// The "they don't know" look: black pen strokes on white paper. Shapes are flat
// unlit WHITE (so they occlude cleanly against the page); their geometry edges
// are drawn as thick BLACK fat-lines. No colour, no shading, no lights — the
// line does all the drawing.
export const PALETTE = {
  paper: 0xffffff, // white page
  fill: 0xffffff, // white shape fill (only edges read)
  line: 0x000000, // black pen stroke
} as const;

// White, unlit, pushed slightly back via polygonOffset so the coincident black
// edge-lines sit cleanly on the surface (no z-fighting).
export function flatWhite(): THREE.MeshBasicMaterial {
  return new THREE.MeshBasicMaterial({
    color: PALETTE.fill,
    polygonOffset: true,
    polygonOffsetFactor: 1,
    polygonOffsetUnits: 1,
  });
}

// Screen-space black "pen" line. `resolution` MUST track the canvas size (set on
// init + resize) or fat lines render with the wrong width / invisibly.
export function blackLine(width: number, height: number): LineMaterial {
  const mat = new LineMaterial({ color: PALETTE.line, linewidth: 3 });
  mat.worldUnits = false; // linewidth in screen pixels
  mat.resolution.set(width, height);
  return mat;
}
